import {
  Amount,
  EndDate,
  FullName,
  PhoneNumber,
  Reason,
  RequestingUnit,
  StartDate,
  TripItinerary,
  TypeVehicle,
} from "./_fields";
import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";

type BusinessVehicleTemplate = {
  FullName: string;
  RequestingUnit: string;
  PhoneNumber: number;
  StartDate: string;
  EndDate: string;
  TripItineraty: string;
  TypeVehicle: string;
  Amount: number;
  Reason: string;
};

export const businessVehicleTemplate: TemplatesValue<BusinessVehicleTemplate> = {
  fileName: "DanhSachDeNghiSuDungXeCongVu",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    FullName,
    RequestingUnit,
    PhoneNumber,
    StartDate,
    EndDate,
    TripItinerary,
    TypeVehicle,
    Amount,
    Reason,
  ],
  fields: [
    "FullName",
    "RequestingUnit",
    "PhoneNumber",
    "StartDate",
    "EndDate",
    "TripItineraty",
    "TypeVehicle",
    "Amount",
    "Reason",
  ],
};
